import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    headerText: {
      fontWeight: 700,
      color: palette.text.primary,
      fontSize: '1.5rem'
    },
    ngoListWrapper: {
      width: '100%',
      display: 'flex',
      gap: '20px',
      justifyContent: 'center',
      alignItems: 'space-between',
      '@media (max-width: 1280px)': {
        flexDirection: 'column'
      }
    },
    stepsList: {
      padding: '0px 20px',
      '& li': {
        padding: '2.5px',
        listStyle: 'inside'
      }
    },
    submitButton: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '15px'
    },
    percentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      alignItems: 'flex-start'
    },
    recapSentence: {
      padding: '12px',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      color: 'black',
      fontSize: '1.25rem'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
